// extracted by mini-css-extract-plugin
export default {"toast":"useMessageToast_toast__6LZ0Z"};